import { createSlice } from '@reduxjs/toolkit';
import { showConfirm, closeConfirm } from './confirmSlice';
import { setEditMessage } from './localizationSlice';

const modalSlice = createSlice({
  name: 'modal',
  initialState: {
    loading: false,
    errors: null,
    content: null,
    callback: null,
    options: {}
  },
  reducers: {
    openModal: (state, action) => {
      const { content, callback, options } = action.payload;
      state.content = content;
      if (callback) state.callback = callback;
      if (options) state.options = options;
      state.loading = false;
    },
    closeModal: (state) => {
      state.content = null;
      state.callback = null;
      state.options = {};
      state.loading = false;
    },
    setOptions: (state, action) => {
      state.options = Object.assign(state.options, action.payload);
    }
  },
  extraReducers: (builder) => {
    builder
      // on showConfirm, stop modal from preventing focus leaving from modal
      .addCase(showConfirm, (state) => {
        if (state.content) {
          state.options = Object.assign({}, state.options, { enforceFocus: false });
        }
      })
      .addCase(closeConfirm, (state) => {
        if (state.content) {
          state.options = Object.assign({}, state.options, { enforceFocus: true });
        }
      })
      // on setEditMessage, stop modal from preventing focus leaving from modal when editing localizations
      .addCase(setEditMessage, (state, action) => {
        if (!state.content) return;

        if (action.payload?.id) {
          state.options = Object.assign({}, state.options, { enforceFocus: false });
        } else {
          state.options = Object.assign({}, state.options, { enforceFocus: true });
        }
      })
  }
});

export const { openModal, closeModal, setOptions } = modalSlice.actions;
export default modalSlice.reducer;